import { GETWORKSPACEMEMBEROKR_SUCCESS, GETWORKSPACEMEMBEROKR_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getworkspacememberOKRReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETWORKSPACEMEMBEROKR_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETWORKSPACEMEMBEROKR_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: [],
            };
        default:
            break;
    }

    return state;
};

export default getworkspacememberOKRReducer;



